var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocTypeVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill: #008724;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_12",
    className: "cls-1",
    d: "M13,26c-3.4,0-6.8-1.4-9.2-3.8C1.4,19.8,0,16.5,0,13c0-3.5,1.4-6.8,3.8-9.2C6.2,1.4,9.5,0,13,0c3.5,0,6.8,1.4,9.2,3.8,2.4,2.4,3.8,5.7,3.8,9.2,0,3.4-1.4,6.8-3.8,9.2-2.4,2.4-5.7,3.8-9.2,3.8ZM6.5,13.1l-1.3,1.3,5.1,5.1,10.9-10.9-1.3-1.3-9.6,9.6-3.8-3.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocTypeVerified);
export default __webpack_public_path__ + "static/media/Icon_DocType_Verified.cd3930a7c5d117263229c43674abb049.svg";
export { ForwardRef as ReactComponent };